import { useState, useEffect, useCallback } from 'react';
import { calculateFileScore } from '../../../utils/excelOperations';
import {
  defaultCalculationSettings,
  mergeWithDefaultCalculationSettings,
} from '../../../utils/defaultSettings';

export const useCalculationSettings = () => {
  const [calculationSettings, setCalculationSettings] = useState(defaultCalculationSettings);

  useEffect(() => {
    const savedSettings = localStorage.getItem('calculationSettings');
    if (savedSettings) {
      try {
        setCalculationSettings(mergeWithDefaultCalculationSettings(JSON.parse(savedSettings)));
      } catch {
        setCalculationSettings(defaultCalculationSettings);
      }
    }
  }, []);

  const recalculateFiles = useCallback(
    (files) => files.map((file) => calculateFileScore(file, calculationSettings)),
    [calculationSettings]
  );

  return { calculationSettings, recalculateFiles };
};
